import axios from 'axios'
import { Base64 } from 'js-base64'

// 创建 Axios 实例  
const instance = axios.create({
  baseURL: 'http://kt.clawevery.com/admin/system.soft/',
})

// 封装请求拦截器  
instance.interceptors.request.use(
  (config) => {

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 封装响应拦截器  
instance.interceptors.response.use(
  (response) => {
    const arrayObject = JSON.parse(Base64.decode(response.data))
    return arrayObject
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance